import {
    standardActionErrorMsg, standardActionSuccessMsg, StandardActionToastMessages
} from '~commonInfra/contentActions/ActionHelpers';
import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { Set } from '~commonInfra/utils/Set';
import { Formatters, Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ISimulationBase } from '~src/simulation/models/ISimulationInfo';
import { Simulations } from '~src/simulation/resources/Simulations';
import { SimulationContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';
import { ChangeTagsActionHelperService } from '~src/tags/ChangeTagsActionHelper';
import { IChangeContentTagsResult } from '~src/tags/IChangeContentTagsAction';

export namespace ChangeSimulationsTagsAction {
  const notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsSimulationsSuccess),
    error: standardActionErrorMsg(Messages.changeTagsSimulationsError),
  };

  export function execute(itemSet: Set<ISimulationBase>): Promise<IChangeContentTagsResult> {
    return ChangeTagsActionHelperService.createExecuteFn<ISimulationBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => Simulations.changeTags(ids, addTags, removeTags),
      getDescription: (simulations: Set<ISimulationBase>) => getDescription(simulations),
      notificationFns: notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<ISimulationBase>) => changeTagsErrorDetail(errorItem)
    })(itemSet);
  }

  function getDescription(simulations: Set<ISimulationBase>) {
    return (simulations.size() === 1)
      ? Messages.changeTagsSimulationDescription({ NAME: L10n.elideIfLong(simulations.first().name) })
      : Messages.changeTagsSimulationsDescription({ COUNT_LOC: Formatters.formatCount(simulations.size()) });
  }

  function changeTagsErrorDetail(errorItem: IErrorItem<ISimulationBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, SimulationContentType),
      errorMessage: ChangeTagsActionHelperService.errorMessageFor(errorItem)
    };
  }
}
